import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BlackList from './black-list';
import BlackListDetail from './black-list-detail';
import BlackListUpdate from './black-list-update';
import BlackListDeleteDialog from './black-list-delete-dialog';
// 路由
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BlackListUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BlackListUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BlackListDetail} />
      <ErrorBoundaryRoute path={match.url} component={BlackList} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:id/delete`} component={BlackListDeleteDialog} />
  </>
);

export default Routes;
